<template>
	<div>
		<!-- 山东建设协会qc小组的注册文件 -->
		<!-- 申请提交 -->
		<div style="width: 1400px;margin-left: auto;margin-right: auto;">
			<!-- 标题 -->
			<div class="formHead">
				<h4>填写注册信息</h4>
				<!-- <div class="formHead_title">
                    <img src="../../assets/img/login/注释.png">
                    <p style="font-size: 14px;">以下带*号内容必须填写！</p>
                </div>-->
			</div>
			<!-- 表单区域 -->
			<div class="form_body">
				<p class="p-title">单位基本信息</p>
				<div style="display: flex;flex-wrap: wrap;margin-top: 20px;">
					<div data-v-022fc800="" class="labelInput" style="width: 500px;">
						<span class="innerSpan" style="color: rgb(0, 0, 0); font-size: 14px; width: 130px;">
							<span style="color: red;">*&nbsp;</span>单位名称:</span>
						<div class="innerP" style="width: auto; font-size: 14px;">
							<div class="el-tooltip el-input" aria-describedby="el-tooltip-1847" tabindex="0">
								<el-select v-model="form.name" filterable remote reserve-keyword placeholder="请输入关键词"
										   :remote-method="remoteMethod" :loading="loading" @change="choose"
										   style="width: 100%">
									<el-option v-for="(item,i) in comoptions" :key="i" :label="item.label"
											   :value="item.label">
									</el-option>
								</el-select>
							</div>
						</div>
					</div>
					<div data-v-022fc800="" class="labelInput" style="width: 500px;">
						<span class="innerSpan" style="color: rgb(0, 0, 0); font-size: 14px; width: 130px;">
							<span style="color: red;">*&nbsp;</span>社会信用代码:</span>
						<div class="innerP" style="width: auto; font-size: 14px;">
							<div class="el-tooltip el-input" aria-describedby="el-tooltip-1847" tabindex="0">
								<!---->
								<el-input v-model.trim="form.tax_number" />
							</div>
						</div>
					</div>
					<!-- 插入两条下拉选项 -->
					<label-input componentWidth="500px" :spanRequired="true" :spanWidth="spanWidth" specilType="limit"
						:maxLimit="18" spanTitle="通讯地址" normalPlace="请输入通讯地址"
						@inputChange="labelInput($event,'address')">
					</label-input>
					<div class="labelInput" style="width: 500px">
						<span data-v-022fc800="" class="innerSpan"
							style="color: rgb(0, 0, 0); font-size: 14px; width: 130px;">
							<span data-v-022fc800="" style="color: red;">*&nbsp;</span>企业注册地:</span>
						<el-select size="small" style="width: 150px;margin-left: 20px" v-model="province"
							placeholder="请选择省份" v-on:change="getProv($event)">
							<el-option v-for="item in provs" :label="item.label" :key="item.value" :value="item.value">
							</el-option>
						</el-select>
						<el-select size="small" style="width: 150px;margin-left: 20px" v-if="province!=''"
							v-model="form.register_address" placeholder="请选择城市" v-on:change="getCity($event)">
							<el-option v-for="item in citys" :label="item.label" :key="item.value" :value="item.value">
							</el-option>
						</el-select>
					</div>
					<label-input :spanRequired="true" :spanWidth="spanWidth" specilType="limit" :maxLimit="10"
						componentWidth="500px" spanTitle="法人代表" normalPlace="请输入法人代表"
						@inputChange="labelInput($event,'legal_person')">
					</label-input>
					<label-input :spanRequired="true" spanTitle="固定电话" :spanWidth="spanWidth" specilType="limit"
						:maxLimit="40" componentWidth="500px" normalPlace="请输入固定电话,区号+号码"
						@inputChange="labelInput($event,'phone')"></label-input>
					<label-input :spanRequired="true" :spanWidth="spanWidth" specilType="limit" :maxLimit="11"
						componentWidth="500px" spanTitle="手机电话" normalPlace="请输入手机号码"
						@inputChange="labelInput($event,'cellphone')">
					</label-input>
					<label-input :spanRequired="false" :spanWidth="spanWidth" componentWidth="500px" spanTitle="企业网址"
						normalPlace="请输入" @inputChange="labelInput($event,'site_url')">
					</label-input>
				</div>
			</div>

			<div class="form_body">
				<!-- <p class="p-title">资质等级</p>
                <div>
                    <div style="display: flex;flex-wrap: wrap;margin-top: 20px;">
                        <normalSelect :spanRequired="true"
                                      pelaceHolder='总承包' @selectCode="typeThreeInput($event,'3')"
                                      :spanWidth="spanWidth" :dataList="List1" componentWidth="500px" spanTitle="总承包">
                        </normalSelect>
                        <normalSelect :spanRequired="true"
                                      pelaceHolder='专业承包' @selectCode="typeThreeInput($event,'4')"
                                      :spanWidth="spanWidth" :dataList="List2" componentWidth="500px" spanTitle="专业承包">
                        </normalSelect>
                        <label-input componentWidth="500px" :spanRequired="false" :spanWidth="spanWidth" specilType="limit"
                                     :maxLimit="255" spanTitle="其他" normalPlace="请输入" @inputChange="labelInput($event,'remark')">
                        </label-input>
                    </div>
                </div> -->

				<p class="p-title">用户基本信息</p>
				<div style="display: flex;flex-wrap: wrap;margin-top: 20px;">
					<!--  -->
					<!--<label-input componentWidth="500px"
                                 :spanRequired="true"
                                 :spanWidth="spanWidth"
                                 spanTitle="登录账号"
                                 normalPlace="自动生成"
                                 :isDisabled="true"
                                 v-model="form.login_account"
                    >
                    </label-input>-->

					<div data-v-804ab448="" class="labelInput" style="width: 500px;">
						<span class="innerSpan" style="color: rgb(0, 0, 0); font-size: 14px; width: 130px;">
							<span style="color: red;">*&nbsp;</span>
							登录账号:
						</span>
						<div class="innerP" style="width: auto; font-size: 14px;">
							<div class="el-tooltip el-input is-disabled" aria-describedby="el-tooltip-608" tabindex="0">
								<el-input placeholder="自动生成" v-model="form.login_account" id="aNo" :disabled="true">
								</el-input>

							</div>
						</div>
					</div>

					<label-input componentWidth="500px" :spanRequired="true" :spanWidth="spanWidth" specilType="limit"
						:maxLimit="11" spanTitle="手机号码" normalPlace="请输入真实手机号,用于接收相关消息通知"
						@inputChange="labelInput($event,'user_cellphone')">
					</label-input>
					<label-input componentWidth="500px" :spanRequired="true" :spanWidth="spanWidth" specilType="limit"
						:maxLimit="10" spanTitle="真实姓名" normalPlace="请输入联络人姓名"
						@inputChange="labelInput($event,'username')">
					</label-input>
					<label-input componentWidth="500px" :spanRequired="true" :spanWidth="spanWidth" specilType="limit"
						:maxLimit="50" spanTitle="电子邮箱" normalPlace="请输入" @inputChange="labelInput($event,'email')">
					</label-input>
					<label-input componentWidth="500px" :spanRequired="true" :spanWidth="spanWidth"
						specilType="password" spanTitle="用户密码" normalPlace="请输入用户密码"
						@inputChange="labelInput($event,'password')"></label-input>
					<label-input componentWidth="500px" :spanRequired="true" :spanWidth="spanWidth"
						specilType="password" spanTitle="密码确认" normalPlace="请输入密码"
						@inputChange="labelInput($event,'password2')"></label-input>
					<div style="width: 100%;color: #FE2e2c;font-size: 14px;padding-left: 108px;">
						<p>提示：密码长度6-24位，至少包含字母、数字、字符任意两种组合</p>
					</div>
					<label-input componentWidth="500px" :spanRequired="false" :spanWidth="spanWidth" specilType="limit"
						:maxLimit="20" spanTitle="工作部门" normalPlace="请输入" @inputChange="labelInput($event,'dep')">
					</label-input>
					<label-input componentWidth="500px" :spanRequired="false" :spanWidth="spanWidth" specilType="limit"
						:maxLimit="20" spanTitle="工作职务" normalPlace="请输入" @inputChange="labelInput($event,'post')">
					</label-input>
					<!--福建工法申报 <label-input componentWidth="500px" :spanRequired="true" :spanWidth="spanWidth" specilType="limit"
                        :maxLimit="20" spanTitle="密码问题" normalPlace="请输入"
                        @inputChange="labelInput($event,'password_question')"></label-input>
                    <label-input componentWidth="500px" :spanRequired="true" :spanWidth="spanWidth" specilType="limit"
                        :maxLimit="20" spanTitle="密码答案" normalPlace="请输入"
                        @inputChange="labelInput($event,'password_answer')"></label-input> -->
				</div>
			</div>
			<div class="form_button">
				<el-button @click="$router.go(-1)">返回</el-button>
				<el-button type="primary" style="background-color: #015aaa;" @click="submitApp()">提交</el-button>
			</div>
		</div>

		<!-- 提交成功 -->
		<div>
			<el-dialog :visible.sync="dialogVisible" width="282px" :show-close="false" :modal="false" top="420px">
				<div class="" style="display: flex;flex-flow: column;justify-content: center;align-items: center;">
					<img src="../../assets/img/login/submit.png" style="width: 40px;height: 40px;margin-bottom: 20px;">
					<span>{{Msg}}</span>
					<!-- <span>如有疑问可联系68048993</span>-->
				</div>
			</el-dialog>
		</div>
		<!-- 注册成功 -->
		<el-dialog :visible.sync="centerDialogVisible" width="400px" :close-on-click-modal="false"
			:close-on-press-escape="false" center>
			<div class="dialogTip">
				<img src="../../assets/img/login/submit.png" alt="">
				<p style="font-size: 24px;font-weight: bold;margin-top: 10px;">恭喜您注册成功</p>
				<p style="margin-top: 10px;">您的账户为：<span
						style="color: #0070C0;font-size: 20px;font-weight: bold;">{{form.login_account}}</span></p>
				<p style="margin-top: 10px;">请妥善保管您的账户信息</p>
				<el-button style="margin-top: 20px;" @click="$router.replace('/index')">去登录</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import labelInput from "../../components/table/labelInput.vue"
	import labelUpload from '../../components/table/labelUpload.vue'
	import labelSelect from '../../components/table/labelSelect.vue'
	import normalSelect from '../../components/table/normalSelect.vue'
	import cityJson from '@/assets/city.json'
	import {
		userRegister,
		getCompanyList ,
		getTaxNumber,
		produceMax
	} from "@/api/moudles/user.js"
	import {
		vaildte
	} from '../../utils/validate.js'
	import CryptoJs from "crypto-js";

	export default {
		data() {
			return {
				centerDialogVisible: false,

				province: '',
				city: '',
				// 参建方式
				List1: [
					[{
							name: '特级',
							code: '特级'
						}, {
							name: '一级',
							code: '一级'
						}, {
							name: '二级',
							code: '二级'
						},
						{
							name: '三级',
							code: '三级'
						},
						{
							name: '无',
							code: '无'
						}
					]
				],

				List2: [
					[{
							name: '一级',
							code: '一级'
						}, {
							name: '二级',
							code: '二级'
						},
						{
							name: '三级',
							code: '三级'
						},
						{
							name: '无',
							code: '无'
						}
					]
				],

				provs: [{
						label: "北京市",
						value: "北京市"
					},
					{
						label: "天津市",
						value: "天津市"
					},
					{
						label: "河北省",
						value: "河北省"
					},
					{
						label: "山西省",
						value: "山西省"
					},
					{
						label: "内蒙古自治区",
						value: "内蒙古自治区"
					},
					{
						label: "辽宁省",
						value: "辽宁省"
					},
					{
						label: "吉林省",
						value: "吉林省"
					},
					{
						label: "黑龙江省",
						value: "黑龙江省"
					},
					{
						label: "上海市",
						value: "上海市"
					},
					{
						label: "江苏省",
						value: "江苏省"
					},
					{
						label: "浙江省",
						value: "浙江省"
					},
					{
						label: "安徽省",
						value: "安徽省"
					},
					{
						label: "福建省",
						value: "福建省"
					},
					{
						label: "江西省",
						value: "江西省"
					},
					{
						label: "山东省",
						value: "山东省"
					},
					{
						label: "河南省",
						value: "河南省"
					},
					{
						label: "湖北省",
						value: "湖北省"
					},
					{
						label: "湖南省",
						value: "湖南省"
					},
					{
						label: "广东省",
						value: "广东省"
					},
					{
						label: "广西壮族自治区",
						value: "广西壮族自治区"
					},
					{
						label: "海南省",
						value: "海南省"
					},
					{
						label: "重庆市",
						value: "重庆市"
					},
					{
						label: "四川省",
						value: "四川省"
					},
					{
						label: "贵州省",
						value: "贵州省"
					},
					{
						label: "云南省",
						value: "云南省"
					},
					{
						label: "西藏自治区",
						value: "西藏自治区"
					},
					{
						label: "陕西省",
						value: "陕西省"
					},
					{
						label: "甘肃省",
						value: "甘肃省"
					},
					{
						label: "青海省",
						value: "青海省"
					},
					{
						label: "宁夏回族自治区",
						value: "宁夏回族自治区"
					},
					{
						label: "新疆维吾尔自治区",
						value: "新疆维吾尔自治区"
					},
					{
						label: "台湾省",
						value: "台湾省"
					},
					{
						label: "香港特别行政区",
						value: "香港特别行政区"
					},
					{
						label: "澳门特别行政区",
						value: "澳门特别行政区"
					}
				],
				citys: [],

				cityChoose: 1,

				form: {
					name: '',
					login_account: '',
					tax_number: '',
					address: '',
					// register_address: '',
					legal_person: '',
					qualification_level: '',
					// member_category: '',
					phone: '',
					cellphone: '',
					site_url: '',
					username: '',
					user_cellphone: '',
					password: '',
					password2: '',
					post: '',
					dep: '',
					email: '',
					password_answer: '',
					password_question: '',
					remark: '', //其他
					// epc: '', //总承包
					// pcg: '', //专业承包

				},
				comoptions: [],
				loading: false,
				Msg: '提交成功，请等待审核',
				dialogVisible: false,
				addressInput: '',
				spanWidth: '130px',
				installList: [
					[{
							name: '副会长单位',
							code: '副会长单位'
						}, {
							name: '监事长单位',
							code: '监事长单位'
						}, {
							name: '副监事长单位',
							code: '副监事长单位'
						},
						{
							name: '理事单位',
							code: '理事单位'
						}, {
							name: '监事单位',
							code: '监事单位'
						}, {
							name: '会员单位',
							code: '会员单位'
						},

					]
				],
				installList2: [
					[{
							name: '福州市',
							code: '福州市'
						}, {
							name: '厦门市',
							code: '厦门市'
						}, {
							name: '泉州市',
							code: '泉州市'
						},
						{
							name: '漳州市',
							code: '漳州市'
						}, {
							name: '莆田市',
							code: '莆田市'
						}, {
							name: '龙岩市',
							code: '龙岩市'
						}, {
							name: '三明市',
							code: '三明市'
						}, {
							name: '南平市',
							code: '南平市'
						}, {
							name: '宁德市',
							code: '宁德市'
						}, {
							name: '平潭综合实验区',
							code: '平潭综合实验区'
						}, {
							name: '福建省外',
							code: '福建省外'
						},
					]
				],
				componentWidth: '740px',
				tipText1: '支持jpg,jpeg,png,pdf等格式请上传正本扫描件、数量不超过1张',
				tipText2: '支持jpg,jpeg,png,pdf等格式请上传正本扫描件、数量不超过5张',
				actionUrl: 'https://jsonplaceholder.typicode.com/posts/',
				typeId: ''
			}
		},
		components: {
			labelInput,
			labelUpload,
			labelSelect,
			normalSelect
		},
		created() {
			let cityChoose = localStorage.getItem('cityChoose')
			this.cityChoose = cityChoose
			// let type = this.getQueryParams()
			// let type1 = JSON.parse(this.decrypt(type))
			// this.typeId = type1.key

			let type = this.getQueryParams()

			console.log(type)
			console.log(877848)

			if(type != 'qcHb'){
				this.$notify.error({
					title: '网址错误',
					message: '网址错误'
				});
				return
			}
			if(type == 'qcHb'){
				this.typeId   = 11
			}

		},
		methods: {

			/**
			 * 解密
			 */
			decrypt(word) {
				let key = CryptoJs.enc.Utf8.parse("1234567890ABCDEF");
				let decrypt = CryptoJs.AES.decrypt(word, key, {
					mode: CryptoJs.mode.ECB,
					padding: CryptoJs.pad.Pkcs7
				});
				return CryptoJs.enc.Utf8.stringify(decrypt).toString();
			},

			getQueryParams() {
				let url = window.location.href; //获取当前url
				let dz_url = url.split('#')[0]; //获取#/之前的字符串
				let cs = dz_url.split('?')[1]; //获取?之后的参数字符串
				let cs_arr = cs.split('&'); //参数字符串分割为数组

				return cs_arr[0].slice(5) //这样就拿到了参数中的数据
			},

			getProv: function(prov) {
				let tempCity = [];
				this.citys = [];
				this.form.register_address = '';
				let allCity = cityJson
				for (var val of allCity) {
					if (prov == val.prov) {
						// console.log(val);
						tempCity.push({
							label: val.label,
							value: val.label
						})
					}
				}
				this.citys = tempCity;
			},
			getCity: function(city) {
				// console.log("选择地市");
				// console.log(city);
				this.produce_max(city)
			},
			async produce_max(city) {
				await produceMax({
					data: {
						city: city
					},
					success: (res) => {
						console.log(res.data)
						this.form.login_account = res.data
					},
					fail: (err) => {
						console.log(err)
					}
				})
			},

			async remoteMethod(query) {
				if (query !== '') {
					let keyword = query
					await getCompanyList({
						data: {
							keyword: keyword
						},
						success: (res) => {
							let data = res.data
							this.list = data.map(item => {
								return {
									value: `${item.creditNo}`,
									label: `${item.name}`
								};
							});
							this.loading = true;
							setTimeout(() => {
								this.loading = false;
								this.comoptions = this.list.filter(item => {
									return item.label.toLowerCase()
										.indexOf(query.toLowerCase()) > -1;
								});
							}, 200);
						},
						fail: (err) => {
							console.log(err)
						}
					})
				} else {
					this.comoptions = [];
				}
			},
			choose(value) {
				this.form.name = value

				this.comoptions.map(item => {
					if(item.label == value){
						this.form.tax_number = item.value
					}
				});
			},
			// 新增参建单位输入
			typeThreeInput(e, type) {
				if (type == '1') { //注册地
					this.form.register_address = e
				} else if (type == '3') { //总承包
					this.form.epc = e
				} else if (type == '4') { //总承包
					this.form.pcg = e
				} else {
					this.form.member_category = e
				}
			},

			async getnum() {
				let keyword = this.form.name
				await getTaxNumber({
					data: {
						keyword: keyword
					},
					success: (res) => {
						this.form.tax_number = res.data
					},
					fail: (err) => {
						console.log(err)
					}
				})
			},

			labelInput(e, name) {
				// console.log('e', e)
				// console.log('index', name)
				this.form[name] = e
			},

			// 提交申请
			async submitApp() {
				console.log(this.form)
				if (this.form.address == '' ||
					// this.form.cellphone == '' ||
					this.form.legal_person == '' ||
					this.form.name == '' ||
					this.form.password == '' ||
					this.form.password2 == '' ||
					this.form.tax_number == '' ||
					this.form.user_cellphone == '' ||
					this.form.email == '' ||
					this.form.phone == ''
				) {
					this.$message({
						message: '存在未填写项',
						type: 'error'
					});
					return false
				}

				if(this.form.login_account ==''){
					this.$message({
						message: '登录账号不能为空，请选择企业注册地省市，自动生成',
						type: 'error'
					});
					return false
				}

				if (!vaildte.isPhone(this.form.cellphone)) {
					this.$message({
						message: '手机电话填写不符合格式',
						type: 'error'
					});
					return false
				}
				if (!vaildte.isPhone(this.form.user_cellphone)) {
					this.$message({
						message: '手机号码填写不符合格式',
						type: 'error'
					});
					return false
				}
				if (!vaildte.isEmail(this.form.email)) {
					this.$message({
						message: '电子邮箱填写不符合格式',
						type: 'error'
					});
					return false
				}
				// 密码验证
				if (this.form.password.length > 5 && this.form.password.length < 25) {
					const rgx = /((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z]))(?!^.*[\u4E00-\u9FA5].*$)/
					if (!rgx.test(this.form.password)) {
						this.$message.error('用户密码不符合要求，密码长度6-24位，至少包含字母、数字、字符任意两种组合')
						return
					}
				} else if (this.form.password.length > 24) {
					this.$message.error('用户密码长度不超过24位')
					return
				} else {
					this.$message.error('用户密码长度不低于6位')
					return
				}
				if (this.form.password !== this.form.password2) {
					this.$message.error('用户密码与确认密码不相等')
					return
				}
				this.form.typeId = this.typeId
				await userRegister({
					data: this.form,
					success: (res) => {
						if (res.code == '-1') {
							this.$message({
								message: res.msg,
								type: 'error'
							});
							return false
						} else {
							this.centerDialogVisible = true
							this.$message({
								message: res.msg,
								type: 'success'
							});
						}
						// setTimeout(() => {
						// 	this.dialogVisible = false
						// 	this.$router.replace('/index')
						// }, 2000)
					},
					fail: (err) => {
						console.log(err)
					}
				})
			},
			showAdd() {

			},
			handleClose() {
				this.$router.replace('/login')
			}
		}
	}
</script>

<style scoped>
	body {
		background-color: #FFFFFF;
	}

	.dialogTip {
		min-height: 350px;
		display: flex;
		flex-flow: column;
		align-items: center;
		justify-content: center;
	}

	>>>.el-dialog {
		border-radius: 18px;
		overflow: hidden;
	}

	.p-title {
		color: #035bab;
		font-size: 16px;
		font-weight: 600;
	}

	>>>.el-dialog__header {
		display: none;
	}

	>>>.el-dialog__body {
		padding: 20px 50px;
	}

	/* form页面 */
	.formHead {
		height: 130px;
		width: 100%;
		display: flex;
		flex-flow: column;
		justify-content: space-evenly;
		align-items: center;
	}

	.formHead h4 {
		font-size: 24px;
		letter-spacing: 1px;
		font-weight: bold;
		color: #0070C0;
	}

	.formHead_title {
		height: 30px;
		line-height: 30px;
		background-color: #ffece6;
		color: #FE2e2c;
		width: 100%;
		display: flex;
		align-items: center;
	}

	.formHead_title img {
		width: 15px;
		height: 15px;
		margin-left: 40px;
		margin-right: 10px;
	}

	/* 表单主体 */
	.form_body {
		width: 1250px;
		margin-left: auto;
		margin-right: auto;
		height: 100%;
	}

	.form_body2 {
		width: 1250px;
		height: 185px;

		display: flex;
		flex-flow: column;
		flex-wrap: wrap;
	}

	.form_body3 {
		min-height: 120px;
		height: auto;
		display: flex;
		align-items: flex-start;
		padding: 10px 0;
	}

	.tbody {
		margin-top: 20px;
		padding: 30px 0;
	}

	.form_button {
		height: 150px;
		display: flex;
		justify-content: center;
	}

	.form_button button {
		margin-top: auto;
		margin-bottom: auto;
		width: 200px;
		height: 35px;
	}

	.body_inner {
		width: 50%;
	}

	/* 消除弹窗头部区域 */
	.el-dialog__header {
		display: none;
	}
</style>
